const React = require("react");
const T = require("prop-types");
const { loadStripe } = require("@stripe/stripe-js");
const { Elements } = require("@stripe/react-stripe-js");
const CheckoutForm = require("components/CheckoutForm").default;

// For some reason the material-ui dialogs are rendering outside the root component tree?
// The provider needs to be loaded here instead.
const stripePromise = loadStripe(process.env.STRIPE_KEY);

const CheckoutFormContainer = props => {
    const options = {
        mode: "payment",
        amount: props.purchaseOption.cost,
        currency: "usd"
    };

    return (
        <Elements stripe={stripePromise} options={options}>
            <CheckoutForm {...props} />
        </Elements>
    );
};

CheckoutFormContainer.propTypes = CheckoutForm.propTypes;

export default CheckoutFormContainer;



// WEBPACK FOOTER //
// ./src/containers/CheckoutForm.js